<!--崇峰定制销售报价单打印模板-->
<template>
    <div v-loading="loading" style="min-height: 400px">
        <div id="printContent" style="color: #000">
            <div :key="index" v-for="(item, index) in printList">
                <div v-if="isEditTitle" class="print-title">
                    <el-input type="text" v-model="titleConfig.RValue" style="width: 200px"></el-input>
                </div>
                <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                <div class="order-detail">
                    <div>{{ item.NeedTime ? '期限日期：' + item.NeedTime : '' }}</div>
                    <div>
                        开单日期：
                        <el-date-picker v-show="openTimeEdit" v-model="item.QTime" value-format="yyyy-MM-dd" type="date" size="small" placeholder="选择日期时间"></el-date-picker>
                        <span v-show="!openTimeEdit">{{ item.QTime }}</span>
                    </div>
                </div>
                <div class="print-table-main">
                    <el-table :data="item.DetailList" :span-method="objectSpanMethod" border="" style="width: 100%" class="fkyou">
                        <el-table-column label="客户名称">
                            <el-table-column label="联系电话">
                                <el-table-column label="UNP码" prop="GoodCode" width="76" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ (scope.row.GoodCode || '').split(',')[0] }}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column :label="item.EntpCusName">
                            <el-table-column :label="item.NeedTime">
                                <el-table-column label="汽配编码" prop="APCode" width="130" show-overflow-tooltip></el-table-column>
                                <el-table-column label="配件名称" prop="GoodName" width="140" show-overflow-tooltip></el-table-column>
                                <el-table-column label="车型" prop="AutoSerise" width="166" show-overflow-tooltip></el-table-column>
                                <el-table-column label="数量" prop="Count" width="50" show-overflow-tooltip></el-table-column>
                                <el-table-column label="单位" prop="Unit" width="50" show-overflow-tooltip></el-table-column>
                                <el-table-column label="单价" prop="MarketPrice" width="68" show-overflow-tooltip></el-table-column>
                                <el-table-column label="总价" prop="TotalPrice" width="80" show-overflow-tooltip></el-table-column>
                                <!-- <el-table-column label="备注" prop="Remark" width="100"  show-overflow-tooltip>
                                </el-table-column>-->
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </div>
                <!--    脚注    -->
                <div class="order-remark" v-show="(remarkConfig.Result && !remarkEdit)|| orderData.IsHaveTitleSet" style="margin-bottom: 20px">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : remarkConfig.RValue }}</div>
                <div class="order-setContent" v-show="remarkEdit">
                    <el-input type="textarea" resize="auto" rows="3" v-model="remarkConfig.RValue"></el-input>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-left-ctn">
                <!--   标题   -->
                <el-button class="btn-primary" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle&& !orderData.IsHaveTitleSet">编辑标题</el-button>
                <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                <el-button class="btn-primary" @click="editConfig(1)" v-show="remarkConfig.Result && !remarkEdit&& !orderData.IsHaveTitleSet">编辑脚注</el-button>
                <el-button class="btn-primary" @click="saveConfig(1)" v-show="remarkEdit">保存脚注</el-button>
                <el-button class="btn-primary" @click="editConfig(2)" v-show="openTimeConfig.Result && !openTimeEdit">设置开单时间</el-button>
                <el-button class="btn-primary" @click="saveConfig(2)" v-show="openTimeEdit">保存开单时间</el-button>
            </div>
            <div class="btn-right-ctn">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: ['printIds'],
    data() {
        return {
            loading: false,
            isEditTitle: false, //编辑标题
            titleConfig: {}, //标题配置
            remarkConfig: {},
            remarkEdit: false,
            openTimeConfig: {},
            openTimeEdit: false,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: this.$util.getLocalStorage('userMsg').EntpName,
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            orderData:{}
        };
    },
    created() {
        this.getConfigByCodes();
    },
    mounted() {
        this.getXJOrder();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['dyyl', 'syllqdysz', 'dybjsm', 'dybjsj', 'dybjbt'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'dyyl':
                                this.isPreview = result;
                                break;
                            case 'syllqdysz':
                                this.isDefaultSet = result;
                                break;
                            case 'dybjsm':
                                this.remarkConfig = data[i];
                                break;
                            case 'dybjsj':
                                this.openTimeConfig = data[i];
                                break;
                            case 'dybjbt':
                                this.titleConfig = data[i];
                                break;
                        }
                    }
                }
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
        .order-detail {
            width: 742px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 10px;
  margin-right: 10px;
  padding: 15px 0;
  color: #000;
}
.company {
  padding: 20px 0;
}
.print-title { width: 762px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.dialog-footer {
  text-align: right;
}
.print-table-main {
  width: 762px;
  margin-bottom: 10px;
  font-size: 12px;
} 
.fkyou {
  border-right: 1px solid #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  margin-bottom: 0px;
  font-size: 14px;
}
.fkyou td {
  padding: 0;
  border-right: 1px solid #000;
  border-top: 1px solid #000;
}
.cell {
    padding-left: 1px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: clip;
  }
.fkyou th {
  padding: 2px;
  border: 1px solid #000; 
}
 
.fkyou div {
  color: #000;
}
.order-remark{
    width: 742px;
}
</style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';
                if (this.printList[0].DetailList.length <= 60) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0],
                        Type: 12
                    },
                    true
                )
                .then(res => {
                    this.isPrint = true;
                    this.loading = false;
                });
        },
        editConfig(type) {
            if (type == 1) {
                this.remarkEdit = true;
            } else if (type == 2) {
                this.openTimeEdit = true;
            }
        },
        saveConfig(type) {
            if (type == 1) {
                if (!this.remarkConfig.RValue || !this.remarkConfig.RValue.trim()) {
                    this.$message.error('请输入脚注');
                    return;
                }
                this.remarkEdit = false;
                this.$util.setSysConfigValue(this.remarkConfig.ConfigId, this.remarkConfig.RValue);
            } else if (type == 2) {
                this.openTimeEdit = false;
            }
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        getXJOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetEntpQuotationOrderPrint',
                    data: {
                        QuoteId: this.printIds[0]
                    },
                    hideLoading: true
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    this.orderData = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].MarketPrice;
                        this.$set(DetailList[i], 'TotalPrice', (DetailList[i].Count * DetailList[i].MarketPrice).toFixed(2));
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice.toFixed(2);
                    data.DetailList.push({
                        AutoSerise: '总数量',
                        Count: this.allNum,
                        MarketPrice: '总价',
                        TotalPrice: this.allPrice
                    });
                    data.DetailList.push({ GoodCode: '客户要求', APCode: data.Remark });
                    this.printList.push(res.data);
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let tableData = this.printList[0];
            if (columnIndex != 0 && tableData && tableData.DetailList && rowIndex == tableData.DetailList.length - 1) {
                return [1, 8];
            }
        }
    }
};
</script>
<style lang="less" scoped>
.order-detail {
    width: 742px;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 15px 0;
    color: #000;
}
.order-setContent {
    margin-bottom: 20px;
}
.company {
    padding: 20px 0;
}
.print-title {
    width: 762px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
}
.dialog-footer {
    text-align: right;
    justify-content: space-between;
    align-items: center;
    .btn-left-ctn {
        // display: inline-block;
        float: left;
    }
    .btn-right-ctn {
        display: inline-block;
        // float: right;;
    }
}
.print-table-main {
    width: 762px;
    margin-left: 1px;
    margin-bottom: 20px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .pall-count {
        text-align: right;
    }
}
</style>
<style lang="less">
#printContent {
    // 1.修改每行的背景色为透明色
    .el-table th,
    .el-table tr {
        background: #fff !important;
    }
    // 2.修改移入到每行的背景色
    .el-table__body tr:hover > td {
        background: #fff !important;
    }
    .el-table div {
        color: #000;
        font-size: 12px;
    }
    .el-table .cell.el-tooltip {
        overflow: hidden !important;
        text-overflow: clip;
    }
    // // 3.修改表格边框颜色
    // // 右边和下边
    // .el-table--border:after,
    // .el-table--group:after,
    // .el-table:before {
    //   background-color: #fff !important;
    // }
    // // 左边和上边
    // .el-table--border,
    // .el-table--group {
    //   border-color: #000 !important;
    // }
    // .el-table td,
    // .el-table th.is-leaf {
    // //   border-bottom: 1px solid #000 !important;
    // border: 1px solid #000 !important;
    // }
    // // 头部的下边框
    // .el-table--border th,
    // .el-table--border th.gutter:last-of-type {
    // //   border-bottom: 1px solid #000 !important;
    // border: 1px solid #000 !important;
    //   padding:0;
    //   color: #000 !important;
    // }
    // // 列表中间的竖线
    // .el-table--border td,
    // .el-table--border th {
    // //   border-right: 1px solid #000 !important;
    // border: 1px solid #000 !important;
    //   padding:0;
    //   color: #000 !important;
    // }

    .el-table--border,
    .el-table--group {
        border-color: #000;
    }
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before {
        background-color: #000;
    }
    .el-table td,
    .el-table--border th,
    .el-table th.is-leaf {
        border-bottom-color: #000;
        padding: 0;
    }
    .el-table--border td,
    .el-table--border th {
        border-right-color: #000;
        padding: 0;
    }
}
</style>
